import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DynamicFormComponent, Itinerary, ToastService } from '../../../core';
import { ItinerariesService } from 'core/services';
import { ItineraryTranslationsQuestionsService } from '../../services/itinerary-translations-questions.service';
import { ItineraryTranslation } from 'core/models';
@Component({
  selector: 'lms-itinerary-translations-editor',
  templateUrl: './itinerary-translations-editor.component.html',
  styleUrls: ['./itinerary-translations-editor.component.scss']
})
export class ItineraryTranslationsEditorComponent implements OnInit {
  @Input() public translations: any[];
  @Input() public itinerary: Itinerary;
  @Input() public selectedTranslation: any;
  @Output() public onUpdateTranslations = new EventEmitter<any>();
  @Output() public cancel = new EventEmitter<any>();
  public questions: any[];
  @ViewChild('itineraryTransForm', { static: true }) private itineraryTransForm: DynamicFormComponent;

  constructor(
    private itinerariesService: ItinerariesService,
    private itineraryTransQuestionService: ItineraryTranslationsQuestionsService,
    private toastService: ToastService
  ) {}

  public ngOnInit(): void {
    this.getItineraryQuestions(this.itinerary, this.translations);
  }

  public submit(translationData: any): void {
    if (translationData) {
      const itineraryTranslation: ItineraryTranslation = this.parseDataToItineraryTrans(translationData);
      if (this.selectedTranslation) {
        this.onUpdate(itineraryTranslation);
      } else {
        this.onCreate(itineraryTranslation);
      }
    }
  }

  private getItineraryQuestions(itinerary: Itinerary, translations: any[]): void {
    this.questions = this.itineraryTransQuestionService.getQuestions(itinerary, translations, this.selectedTranslation);
  }

  private onCreate(itineraryTranslation: ItineraryTranslation): void {
    this.itinerariesService
      .createItineraryTranslation(itineraryTranslation, this.itinerary.id)
      .then((updatedItineraryTrans) => {
        this.onUpdateTranslations.emit(updatedItineraryTrans);
        this.itineraryTransForm.submitted(null);
      })
      .catch((err) => {
        console.error(err);
        this.toastService.showError(err);
        this.itineraryTransForm.submitted(err);
      });
  }

  private onUpdate(itineraryTranslation: ItineraryTranslation): void {
    this.itinerariesService
      .updateItineraryTranslation(itineraryTranslation, this.itinerary.id)
      .then((updatedItineraryTrans) => {
        this.onUpdateTranslations.emit(updatedItineraryTrans);
        this.itineraryTransForm.submitted(null);
      })
      .catch((err) => {
        console.error(err);
        this.toastService.showError(err);
        this.itineraryTransForm.submitted(err);
      });
  }

  private parseDataToItineraryTrans(data: any): ItineraryTranslation {
    const { translation } = data;
    const currentTranslation = {
      ...this.translations.find((trans) => translation.lang === trans.lang)
    };
    return { ...currentTranslation, ...translation };
  }
}
